/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rte_Heading1Inputs */



/**
* | output |
* | --- |
* | "Heading 1" |
*
* @param {Rte_Heading1Inputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const rte_heading1 = /** @type {((inputs?: Rte_Heading1Inputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rte_Heading1Inputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Kop 1")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Titre 1")
	return /** @type {LocalizedString} */ ("Heading 1")
});